export { Label } from './Label';
export type { LabelProps } from './Label';
